import { Component, EventEmitter } from '@angular/core'
import { PostActions } from 'actions/post-actions'
import { BasePostForm } from './base-post-form.component'

@Component({
  selector: 'take-back-post-form',
  styles: [`
  `],
  template: `
    <h4>Take back post</h4>
    <p>
      If a writer has not made the edits you requested you can take the post back and accept or decline it as is.<br />
      This will cancel your edit request and delete all your latest comments. If you want to add to your current edit request you suggest you wait until the writer completes the current round.<br />
      This option will place this post in the last position of your queue.
    </p>

    <div class="top-buffer">
      <button (click)="execute()" [disabled]="submitted" class="btn btn-warning float-right submit-{{post.id}}">
        {{ submitted ? 'Submitting...' : 'Take Back' }}
      </button>
      <button class="btn btn-default float-right" style="margin-right: 10px;" (click)="onClose()">Cancel</button>
      <div style="clear: both;"></div>
    </div>
  `
})
export class TakeBackPostForm extends BasePostForm {
  deprecatedStoreChange: EventEmitter<number> = new EventEmitter<number>()

  constructor(private postActions: PostActions) {
    super()
  }

  execute(): void {
    this.submitted = true
    this.postActions.takeBack(this.post.customerId, this.post.id).then(() => {
      this.submitted = false
      this.onClose()
      this.deprecatedStoreChange.emit() // refetch all
    })
  }
}
